import React from 'react';
import {
  FDDivider,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import {
  TaxDashboardWizardWrapper,
} from 'Views/Page/Content/Modal/Layouts/TaxDashboardWizard/Components/TaxDashboardWizardWrapper';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Contribution } from '../../Components/Contribution';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <TaxDashboardWizardWrapper>
      <FDStack direction="column" spacing={4}>
        <MetaControlField attr={'body'} {...dataAttrs('dashboard-review-kickoff-wizard-body')} />
        <MetaControlField attr={'questionText'} {...dataAttrs('dashboard-review-kickoff-wizard-question-text')} />
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'contributionHeading'} />
          <FDStack direction={'column'} spacing={3}>
            {resource.attr('contributions') && resource.attr('contributions')?.resources()?.list()?.map((account, idx) => (
              <>
                <Contribution resource={account} key={account.id()} />
                {idx !== resource.attr('contributions')?.resources()?.list()?.length - 1 && <FDDivider />}
              </>
            ))}
          </FDStack>
        </FDStack>

        {/* Disclosure */}
        <MetaControlField attr={'disclosure'} {...dataAttrs('dashboard-review-wizard-disclosure')} />
      </FDStack>
    </TaxDashboardWizardWrapper>
  );
};

export default Layout;
